import React from 'react';
import { createSvgIcon } from '@material-ui/core/utils';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M12 3.923c-4.461 0-8.077 3.616-8.077 8.077S7.539 20.077 12 20.077s8.077-3.616 8.077-8.077S16.461 3.923 12 3.923zm0 14.808a6.73 6.73 0 110-13.462 6.73 6.73 0 010 13.462z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.119 12a6.12 6.12 0 11-12.24-.001A6.12 6.12 0 0118.12 12z"
})), 'Camerabutton');